import React, { useState } from "react";
import { FaDesktop, FaMobileAlt, FaAndroid, FaUserTie, FaShoppingCart, FaGlobe } from "react-icons/fa";
import { FaIndustry } from "react-icons/fa6";

import Distributor_Request from "../../../assets/Docs/Distributor_Request.png";
import Confirm_Request from "../../../assets/Docs/Confirm_Request.png";
import Select_distributor_role from "../../../assets/Docs/Select_distributor_role.png";
import View_Distributors from "../../../assets/Docs/View_Distributors.png";
import { TagComponent } from "../Tabs";

const Suppliers = () => {
  const [activeTab2, setActiveTab2] = useState('web');

  const tabs = [
    { id: 'web', label: 'Web App', icon: <FaDesktop /> },
    { id: 'mobile', label: 'Mobile App', icon: <FaMobileAlt />, disabled: true },
  ];

  const renderTabs = (activeState, setActiveState) => (
    <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => !tab.disabled && setActiveState(tab.id)}
          className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
            ? "bg-[#1a9588] text-white shadow"
            : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
            } ${tab.disabled ? "opacity-50 cursor-not-allowed hover:bg-[#dbf4f1]" : ""}`}
          disabled={tab.disabled}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );

  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">


      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <FaIndustry className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Suppliers</h1>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="green" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="pink" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="green" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>


      {/* Intro Text */}
      <div className="bg-gray-50 p-6 rounded-2xl mb-10">
        <p className="text-gray-700 text-start text-base leading-relaxed ">
          To begin placing orders on the Selzor platform, first add your ‘Supplier’. They must be a registered ‘Seller’ and you should have their Selzor App Code.
        </p>

      </div>

      <div className="text-start my-4">
        <h3 className="text-2xl text-gray-500 mb-2 font-semibold"> Supplier accepts</h3>
        <p className="text-gray-400 mb-6">
          Once the supplier accepts the request, a confirmation step will
          appear.
        </p>
      </div>
      {renderTabs(activeTab2, setActiveTab2)}
      <div className="rounded-lg p-2 sm:p-4 flex justify-start">
        <img
          src={Distributor_Request}
          alt={`${activeTab2} view`}
          className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
        />
      </div>


      <div className="text-start my-4">
        <h3 className="text-2xl text-gray-500 mb-2 font-semibold"> Confirmation</h3>
        <p className="text-gray-400 mb-6">
          At this stage, confirmation will be asked before proceeding.
        </p>
      </div>
      {renderTabs(activeTab2, setActiveTab2)}
      <div className="rounded-lg p-2 sm:p-4 flex justify-start">
        <img
          src={Confirm_Request}
          alt={`${activeTab2} view`}
          className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
        />
      </div>

      <div className="text-start my-4">
        <h3 className="text-2xl text-gray-500 mb-2 font-semibold"> Role selection</h3>
        <p className="text-gray-400 mb-6">
          After confirmation, the user can choose whether they want to connect
          as a Distributor or as a Buyer.
        </p>
      </div>
      {renderTabs(activeTab2, setActiveTab2)}
      <div className="rounded-lg p-2 sm:p-4 flex justify-start">
        <img
          src={Select_distributor_role}
          alt={`${activeTab2} view`}
          className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
        />
      </div>

      <div className="mt-4 bg-yellow-100 text-orange-600 p-3 rounded text-start">
        Distributor Code once defined, cannot be changed.
      </div>

      <div className="text-start my-4">
        <h3 className="text-2xl text-gray-500 mb-2 font-semibold"> Final connection</h3>
        <p className="text-gray-400 mb-6">
          Based on the selected role, the buyer and supplier will be
          successfully connected.
        </p>
      </div>
      {renderTabs(activeTab2, setActiveTab2)}
      <div className="rounded-lg p-2 sm:p-4 flex justify-start">
        <img
          src={View_Distributors}
          alt={`${activeTab2} view`}
          className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
        />
      </div>

    </div>
  );
};

export default Suppliers;